(function() {
    'use strict';

    angular.module('app.ordenes', []);
})();
